import { useState, useEffect } from "react";
export function useGeoFence(radius = 400) {
  const [allowed, setAllowed] = useState(false);
  const [permissionState, setPermissionState] = useState("prompt");
  const [debugInfo, setDebugInfo] = useState(null); // ⬅️ new

  const OFFICE_OLD = { lat: 30.03722, lon: 31.46988 };
  const OFFICE = { lat: 29.99709, lon: 31.52856 };
  // dont forget to update OFFICE in Home.js for iOS
  
  useEffect(() => {
    navigator.permissions?.query({ name: "geolocation" }).then((result) => {
      setPermissionState(result.state);
      result.onchange = () => setPermissionState(result.state);
    });

    if (permissionState !== "granted") return;

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {


        const toRad = (d) => (d * Math.PI) / 180;
        const R = 6371e3;

        const dLat = toRad(coords.latitude - OFFICE.lat);
        const dLon = toRad(coords.longitude - OFFICE.lon);

        const a =
          Math.sin(dLat / 2) ** 2 +
          Math.cos(toRad(OFFICE.lat)) *
            Math.cos(toRad(coords.latitude)) *
            Math.sin(dLon / 2) ** 2;

        const dist = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        setAllowed(dist <= radius);

        // ⬅️ Save debug info to state
        setDebugInfo({
          userLat: coords.latitude.toFixed(6),
          userLon: coords.longitude.toFixed(6),
          officeLat: OFFICE.lat,
          officeLon: OFFICE.lon,
          distance: Math.round(dist),
          accuracy: Math.round(coords.accuracy),
        });
      },
      (err) => {
        console.warn("❌ Geolocation error", err);
        setAllowed(false);
        setDebugInfo({ error: err.message });
      },
      { enableHighAccuracy: true }
    );
  }, [permissionState, radius]);

  return { allowed, permissionState, debugInfo };
}





// import { useState, useEffect } from "react";

// export function useGeoFence(radius = 40) {
//   const [allowed, setAllowed] = useState(false); // Default to false for production
//   const [permissionState, setPermissionState] = useState("prompt");

//   useEffect(() => {
//     navigator.permissions?.query({ name: "geolocation" }).then(result => {
//       setPermissionState(result.state);
//       result.onchange = () => setPermissionState(result.state);
//     });

//     if (permissionState !== "granted") return;

//   navigator.geolocation.getCurrentPosition(
//     ({ coords }) => {
//       const toRad = d => (d * Math.PI) / 180;
//       const R = 6371e3;

//       const dLat = toRad(coords.latitude - OFFICE.lat);
//       const dLon = toRad(coords.longitude - OFFICE.lon);

//       const a =
//         Math.sin(dLat / 2) ** 2 +
//         Math.cos(toRad(OFFICE.lat)) *
//           Math.cos(toRad(coords.latitude)) *
//           Math.sin(dLon / 2) ** 2;

//       const dist = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

//       console.log("📍 User location:", coords.latitude, coords.longitude);
//       console.log("🏢 Office location:", OFFICE.lat, OFFICE.lon);
//       console.log("📏 Distance:", Math.round(dist), "meters");
//       console.log("🔎 Accuracy:", coords.accuracy, "meters");
//       setAllowed(dist <= radius);
//     },
//     (err) => {
//       console.warn("❌ Geolocation error", err);
//       setAllowed(false);
//     },
//     { enableHighAccuracy: true }
//   );
// }, [permissionState,radius]);
//   return {allowed, permissionState};
// }

// // ✅ Your actual office coordinates here
// const OFFICE = { lat: 30.03722, lon: 31.46988 };





// import { useState, useEffect } from "react";

// export function useGeoFence(radius = 40) {
//   const [allowed, setAllowed] = useState(true);
//   // const [allowed, setAllowed] = useState(false);
//   useEffect(() => {
//     navigator.geolocation.getCurrentPosition(
//       ({ coords }) => {
//         const toRad = d => (d * Math.PI) / 180;
//         const R = 6371e3;
//         const dLat = toRad(coords.latitude - OFFICE.lat);
//         const dLon = toRad(coords.longitude - OFFICE.lon);
//         const a =
//           Math.sin(dLat/2)**2 +
//           Math.cos(toRad(OFFICE.lat)) * Math.cos(toRad(coords.latitude)) *
//           Math.sin(dLon/2)**2;
//         const dist = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
//         // setAllowed(dist <= radius);
//         setAllowed(true);
//       },
//       () => setAllowed(true),
//       // () => setAllowed(false),
//       { enableHighAccuracy: true }
//     );
//   }, []);
//   return allowed;
// }

// const OFFICE = { lat: 30.041296, lon: 31.470248 }; // your TEST coords
// const OFFICE = { lat: 30.037263, lon: 31.469915 }; // your coords
